export default "__VITE_ASSET__B4pra_u9__"